export const reCaptchaKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
